// extracted by mini-css-extract-plugin
module.exports = {"bottomLine":"Index_bottomLine__1C4Mf","Main":"Index_Main__1Djep"};